import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7fb0746f&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb0746f')) {
      api.createRecord('7fb0746f', component.options)
    } else {
      api.reload('7fb0746f', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7fb0746f&", function () {
      api.rerender('7fb0746f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kcVIQZ1h51P7/JS/pricehelp.vue"
export default component.exports